import { render, staticRenderFns } from "./RemediatedWidget.vue?vue&type=template&id=11a2fd1d&"
import script from "./RemediatedWidget.vue?vue&type=script&lang=js&"
export * from "./RemediatedWidget.vue?vue&type=script&lang=js&"
import style0 from "./RemediatedWidget.vue?vue&type=style&index=0&id=11a2fd1d&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports